import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { injectGlobal } from 'styled-components';
import 'antd/dist/antd.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);

// tslint:disable-next-line:no-unused-expression
injectGlobal`
  html, body{
    height: 100%;
  }

  #root{
    min-height: 100%;
  }

  .page{
    min-height: 100vh;
  }
`;

if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.tsx